import { ContextParser } from '../classes/ContextParser';

const parser = new ContextParser();

onmessage = (event) => {
    parser.parseData(event.data.code, event.data.fileName, event.data.onlyErrors, event.data.keepData);
    postMessage(parser);
};
